import React, { FC, useEffect, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty, isNull, uniqueId } from 'lodash';
import { toast } from 'react-toastify';
import { v4 as uuidV4 } from 'uuid';
import CustomAccordion from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/CustomAccordion';
import { COLORS } from 'constants/design';
import Request from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/Request';
import DamageAffectedByTheProcedure from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/DamageAffectedByTheProcedure';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import Audience from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/Audience';
import requestRecap from 'images/requestRecap.svg';
import * as utils from 'containers/RecapManagerPage/utils';
import victimIcon from 'images/victim-icon.svg';
import opposing from 'images/opposing.svg';
import { Listings, SagisConfig } from 'containers/AppContainer/typings';
import {
  CIVIL_PROCEEDING_INFORMATIONS_FIELDS,
  LISTINGS,
} from 'containers/data-structure';
import { ITEM_KEYS, SAGIS_KEYS } from 'containers/RecapManagerPage/constants';
import { CivilProceedingInfo } from 'containers/LawyerLegalProceedingsPage/typings';
import {
  ALL_STATUS,
  EMPTY_CIVIL_PROCEEDING_INFO_FIELDS,
} from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/constants';
import AssignedLawyer from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/AssignedLawyer';
import SupportingDocuments from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/SupportingDocuments';
import AssignmentDialog from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/AssignmentDialog';
import { rcCoporeal } from 'containers/CourtManagerLegalProceedings/constants';
import {
  formatCorpoVictims,
  formatUpdateAssignementCivilProceeding,
  formatVictims,
  getNoneExistingVehiculeSagis,
  getNoneExistingVictimSagis,
} from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/utils';
import currentUserStorage from 'containers/services/security/current-user-storage';
import {
  formatOpposingParties,
  getRiskIdFromPolicyInfo,
} from 'containers/CourtManagerLegalProceedings/utils';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { StyledDiv } from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/styled-components';
import RejectionDialog from 'containers/LawyerLegalProceedingsPage/CivilProceedingRecap/RejectionDialog';
import { resolveSagisClaim } from 'helpers/utils';
import {
  PRIVILEGES,
  userHasPrivilege,
} from 'containers/services/security/user-privileges';
import JudgementAddDocumentDecisionRecap from 'containers/common/LegalProceedings/JudgementAdd/Recap/JudgementAddDocumentDecisionRecap';
import { DEFAULT_INTERVENANT_CODE } from 'containers/RecapPage/canstants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { removeDeletedItems } from 'services/utils';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';
import {
  formatCourtFileNumber,
  validationCourtFileNumber,
} from 'containers/LawyerLegalProceedingsPage/judgementAdd/utils';
import { ClaimRecapType } from 'typings/claimTypes';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';

export interface CivilProceedingRecapProps {
  intl: IntlShape;
  civilProceeding: any[];
  claimRecap: ClaimRecapType;
  listings: Listings;
  judiciaryProcessId: number;
  corporealLawyers: any;
  isManager: boolean;
  validateUpdateRequest?: Function;
  lossDate: any;
  requestCorporealLawyers?: Function;
  requestValidatedCivilProceeding?: Function;
  requestSagisClaimInfo?: Function;
  sagisClaim?: {};
  policyInfo: { sagis: {} };
  handleOpenUpdateForm: Function;
  judgementAdd?: any;
  judgementOnMerits?: any;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  isConsultation: boolean;
  requestGetDocByDocumentumId: Function;
}
const Picker = {
  REJECTED: ({ ...props }) => (
    <SecondaryButton
      title={translate(messages.rejectDecision, props)}
      disabled={true}
      style={{ float: 'right' }}
    />
  ),
  VALIDATED: ({ ...props }) => (
    <SecondaryButton
      title={translate(messages.validationDecision, props)}
      disabled={true}
      style={{ float: 'right' }}
    />
  ),
} as any;

const CivilProceedingRecap: FC<CivilProceedingRecapProps> = props => {
  const { civilProceeding, judiciaryProcessId, claimRecap, listings } = props;
  const [civilProceedingInfo, setCivilProceedingInfo] = useState<
    CivilProceedingInfo
  >({
    ...EMPTY_CIVIL_PROCEEDING_INFO_FIELDS,
  });

  const [isUpdated, setIsUpdated] = useState(false);
  const [stakeholders, setStakeholders] = useState([] as SagisConfig[]);
  const info =
    civilProceeding.find(
      civilPro => civilPro?.id === props.judiciaryProcessId,
    ) || {};

  const [dropDown, setDropDown] = useState<null | HTMLElement>(null);

  const [isAssignmentDialogOpen, setIsAssignmentDialogOpen] = React.useState<
    boolean
  >(false);
  const [isRejectionDialogOpen, setIsRejectionDialogOpen] = React.useState<
    boolean
  >(false);

  useEffect(() => {
    const _stackholders = utils.getListBySagisKey(
      get(props.listings, LISTINGS.STACKHOLDER_TYPE, []),
      get(props.listings, LISTINGS.STACKHOLDERS, []),
      ITEM_KEYS.LAWYER,
      SAGIS_KEYS.ITEM_TYPE as keyof SagisConfig,
    );

    const lawyers = utils.getBawabaLawyers(
      _stackholders,
      props.corporealLawyers,
    );
    setStakeholders(lawyers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.listings]);

  useEffect(() => {
    setCivilProceedingInfo({
      ...info,
      assignment: isEmpty(info.assignment)
        ? []
        : info.assignment
            .filter((item: any) => !get(item, 'isDeleted', false))
            .map((el: { assignedLawyer: string }) => el.assignedLawyer),
      assignedLawyers: isEmpty(info.assignment)
        ? []
        : info.assignment
            .filter((item: any) => !get(item, 'isDeleted', false))
            .map((el: { assignedLawyer: string }) => el.assignedLawyer),
    });
  }, [info, civilProceeding, judiciaryProcessId]);

  useEffect(() => {
    props.requestSagisClaimInfo &&
      props.requestSagisClaimInfo(get(claimRecap, 'claim.claimNumber', ''));
  }, [props.claimRecap]);

  const handleCloseAssignmentDialog = () => {
    setIsAssignmentDialogOpen(false);
  };

  const riskKey =
    props.policyInfo &&
    get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []).find(
      (element: { riskName: string }) => element.riskName === rcCoporeal,
    )?.riskId;

  const riskId = getRiskIdFromPolicyInfo(get(props, 'policyInfo', {}));

  const validationDialog = () => {
    const claimResponsabilityRate =
      props.policyInfo &&
      get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []).find(
        (element: { riskName: string }) => element.riskName === rcCoporeal,
      )?.responsibilityRate;
    const formattedVictims = formatVictims(
      getNoneExistingVictimSagis(
        civilProceedingInfo,
        get(props, 'sagisClaim', []),
      ),
      claimResponsabilityRate,
      props.listings,
    );

    props.requestValidatedCivilProceeding &&
      props.requestValidatedCivilProceeding(
        {
          id: props.judiciaryProcessId,
          ...civilProceedingInfo,
          status: ALL_STATUS.VALIDATED,
          victims: formatCorpoVictims(
            civilProceedingInfo,
            get(props, 'sagisClaim', []),
          ),
          victimsSagis: !isEmpty(formattedVictims)
            ? formattedVictims
            : undefined,
          username: currentUserStorage.get().username,
          updateSagisIntervenantProvision: featureService.hasFeature(
            FEATURES.EVOLUTION_P3,
          )
            ? false
            : true,
          claimNumbers: get(props.claimRecap, 'claim.claimNumber'),
          riskKey: riskKey,
          isMonitoringCourtManager: userHasPrivilege(
            PRIVILEGES.ISCOURTMONITORINGMANAGER,
          ),
          opposingParties: !isEmpty(
            getNoneExistingVehiculeSagis(
              get(props, 'sagisClaim', []),
              get(props, 'policyInfo', {}),
              civilProceedingInfo,
            ),
          )
            ? formatOpposingParties(
                Object.values(
                  getNoneExistingVehiculeSagis(
                    get(props, 'sagisClaim', []),
                    get(props, 'policyInfo', {}),
                    civilProceedingInfo,
                  ),
                ),
                riskId,
                get(props.claimRecap, 'claim.claimNumber'),
                get(props.claimRecap, 'claim.id'),
                props.listings?.compagnies,
              )
            : undefined,
          isLawyerInboxesActive: featureService.hasFeature(
            FEATURES.LAWYER_INBOXES,
          ),
        },
        successCallBack,
      );
  };

  const rejectionDialog = () => {
    const formattedAssignedLawyer = formatUpdateAssignementCivilProceeding(
      info,
      civilProceedingInfo,
      get(props.claimRecap, 'claim.lossDate'),
      props.listings,
    );
    props.validateUpdateRequest &&
      props.validateUpdateRequest(
        {
          id: props.judiciaryProcessId,
          JudiciaryProcessInfo: {
            ...civilProceedingInfo,
            assignedLawyers: formattedAssignedLawyer,
            status: ALL_STATUS.REJECTED,
            username: currentUserStorage.get().username,
            courtNumber: formatCourtFileNumber(
              get(civilProceedingInfo, 'courtNumber'),
            ),
            isTrackingActive: featureService.hasFeature(
              FEATURES.TRACKING_ACTIONS_USER,
            ),
          },
          username: currentUserStorage.get().username,
          isInboxesActive: featureService.hasFeature(
            FEATURES.ATTRIBUTION_INBOXES_MANAGER,
          ),
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
          isMonitoringCourtManager: false,
          isLawyerInboxesActive: featureService.hasFeature(
            FEATURES.LAWYER_INBOXES,
          ),
        },
        successCallBack,
      );
  };

  const onValidate = (toUpdate: boolean) => () => {
    const claimResponsabilityRate =
      props.policyInfo &&
      get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []).find(
        (element: { riskName: string }) => element.riskName === rcCoporeal,
      )?.responsibilityRate;
    const formattedAssignedLawyer = formatUpdateAssignementCivilProceeding(
      info,
      civilProceedingInfo,
      get(props.claimRecap, 'claim.lossDate'),
      props.listings,
    );
    const formattedVictims = formatVictims(
      getNoneExistingVictimSagis(
        civilProceedingInfo,
        get(props, 'sagisClaim', []),
      ),
      claimResponsabilityRate,
      props.listings,
    );
    props.validateUpdateRequest &&
      props.validateUpdateRequest(
        featureService.hasFeature(FEATURES.ASSIGNMENT_MULTIPLE_LAWYERS) &&
          !isEmpty(get(info, 'assignment', '')) &&
          !toUpdate
          ? {
              id: props.judiciaryProcessId,
              isInboxesActive: featureService.hasFeature(
                FEATURES.ATTRIBUTION_INBOXES_MANAGER,
              ),
              JudiciaryProcessInfo: {
                ...civilProceedingInfo,
                assignedLawyers: formattedAssignedLawyer,
                status: toUpdate
                  ? get(civilProceedingInfo, 'status')
                  : ALL_STATUS.VALIDATED,
                username: currentUserStorage.get().username,
                courtNumber: formatCourtFileNumber(
                  get(civilProceedingInfo, 'courtNumber'),
                ),
                isTrackingActive: featureService.hasFeature(
                  FEATURES.TRACKING_ACTIONS_USER,
                ),
                victims: !toUpdate
                  ? formatCorpoVictims(
                      civilProceedingInfo,
                      get(props, 'sagisClaim', []),
                    )
                  : get(civilProceedingInfo, 'victims', []),
              },
              username: currentUserStorage.get().username,
              toUpdate,
              isMonitoringCourtManager: false,
              isTrackingActive: featureService.hasFeature(
                FEATURES.TRACKING_ACTIONS_USER,
              ),
              updateSagisIntervenantProvision: featureService.hasFeature(
                FEATURES.EVOLUTION_P3,
              )
                ? false
                : true,
              intervenantSagis: featureService.hasFeature(
                FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
              )
                ? removeDeletedItems(formattedAssignedLawyer).map(
                    (element: any) => ({
                      intervenantTypeCode: DEFAULT_INTERVENANT_CODE,
                      intervenantCode: element?.assignedLawyer,
                    }),
                  )
                : get(civilProceedingInfo, 'assignedLawyers').map(
                    (element: any) => ({
                      intervenantTypeCode: DEFAULT_INTERVENANT_CODE,
                      intervenantCode: element,
                    }),
                  ),
              claimNumbers: get(props.claimRecap, 'claim.claimNumber'),
              victims: !toUpdate
                ? formatCorpoVictims(
                    civilProceedingInfo,
                    get(props, 'sagisClaim', []),
                  )
                : [],
              victimsSagis:
                !toUpdate && !isEmpty(formattedVictims)
                  ? formattedVictims
                  : undefined,
              riskKey: riskKey,
              opposingParties: !isEmpty(
                getNoneExistingVehiculeSagis(
                  get(props, 'sagisClaim', []),
                  get(props, 'policyInfo', {}),
                  civilProceedingInfo,
                ),
              )
                ? formatOpposingParties(
                    Object.values(
                      getNoneExistingVehiculeSagis(
                        get(props, 'sagisClaim', []),
                        get(props, 'policyInfo', {}),
                        civilProceedingInfo,
                      ),
                    ),
                    riskId,
                    get(props.claimRecap, 'claim.claimNumber'),
                    get(props.claimRecap, 'claim.id'),
                    props.listings?.compagnies,
                  )
                : undefined,
              isAutomaticAssignement: featureService.hasFeature(
                FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
              ),
              assignementDetails: {
                contractorFees: featureService.hasFeature(
                  FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
                )
                  ? removeDeletedItems(formattedAssignedLawyer).map(
                      (element: any) => ({
                        uniqueId: uniqueId(),
                        contractorTypeCode: DEFAULT_INTERVENANT_CODE,
                        contractorCode: element.assignedLawyer,
                        amount: 0,
                        isPayment: false,
                      }),
                    )
                  : get(civilProceedingInfo, 'assignedLawyers').map(
                      (element: any) => ({
                        uniqueId: uniqueId(),
                        contractorTypeCode: DEFAULT_INTERVENANT_CODE,
                        contractorCode: element.assignedLawyer,
                        amount: 0,
                        isPayment: false,
                      }),
                    ),
                uuid: uuidV4(),
              },
              isLawyerInboxesActive: featureService.hasFeature(
                FEATURES.LAWYER_INBOXES,
              ),
            }
          : {
              id: props.judiciaryProcessId,
              isInboxesActive: featureService.hasFeature(
                FEATURES.ATTRIBUTION_INBOXES_MANAGER,
              ),
              JudiciaryProcessInfo: {
                ...civilProceedingInfo,
                username: currentUserStorage.get().username,
                assignedLawyers: featureService.hasFeature(
                  FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
                )
                  ? formattedAssignedLawyer
                  : undefined,
                courtNumber: formatCourtFileNumber(
                  get(civilProceedingInfo, 'courtNumber'),
                ),
                isAutomaticAssignement: featureService.hasFeature(
                  FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
                ),
                isTrackingActive: featureService.hasFeature(
                  FEATURES.TRACKING_ACTIONS_USER,
                ),
                updatedBy: currentUserStorage.get().username,
              },
              toUpdate,
              claimNumbers: get(props.claimRecap, 'claim.claimNumber'),
              isMonitoringCourtManager: false,
              username: currentUserStorage.get().username,
              updateSagisIntervenantProvision: featureService.hasFeature(
                FEATURES.EVOLUTION_P3,
              )
                ? false
                : true,
              intervenantSagis: featureService.hasFeature(
                FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
              )
                ? formattedAssignedLawyer
                    .filter((el: any) => !el.isDeleted && !el.id)
                    .map((element: any) => ({
                      intervenantTypeCode: DEFAULT_INTERVENANT_CODE,
                      intervenantCode: element?.assignedLawyer,
                    }))
                : undefined,
              assignementDetails: featureService.hasFeature(
                FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
              )
                ? {
                    contractorFees:
                      featureService.hasFeature(
                        FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
                      ) &&
                      formattedAssignedLawyer
                        .filter((el: any) => !el.isDeleted && !el.id)
                        .map((element: any) => ({
                          uniqueId: uniqueId(),
                          contractorTypeCode: DEFAULT_INTERVENANT_CODE,
                          contractorCode: element.assignedLawyer,
                          amount: 0,
                          isPayment: false,
                        })),
                    uuid: uuidV4(),
                  }
                : undefined,
              isLawyerInboxesActive: featureService.hasFeature(
                FEATURES.LAWYER_INBOXES,
              ),
            },
        successCallBack,
      );
  };

  const onRejection = () => {
    setCivilProceedingInfo({
      ...civilProceedingInfo,
      status: ALL_STATUS.REJECTED,
    });
    setIsRejectionDialogOpen(true);
  };
  const showValidationButton = () => {
    return props.isManager &&
      get(civilProceedingInfo, 'status') === ALL_STATUS.PENDING
      ? true
      : false;
  };
  const dropDownMenuElements = () => {
    const validations = [
      {
        title: translate(messages.validButton, props),
        action: onValidate(false),
        disabled: featureService.hasFeature(
          FEATURES.ASSIGNEMENT_JURISDICTION_LAWYER_REQUEST,
        )
          ? !validationCourtFileNumber(
              get(civilProceedingInfo, [
                CIVIL_PROCEEDING_INFORMATIONS_FIELDS.COURT_NUMBER,
              ]),
            )
          : isEmpty(get(civilProceedingInfo, 'assignedLawyers', [])) ||
            !validationCourtFileNumber(
              get(civilProceedingInfo, [
                CIVIL_PROCEEDING_INFORMATIONS_FIELDS.COURT_NUMBER,
              ]),
            ),
      },
      {
        title: translate(messages.rejectButton, props),
        action: onRejection,
      },
    ];
    const updateJudiciaryProcess = {
      title: translate(messages.updateJudiciaryProcess, props),
      action: onValidate(true),
      disabled:
        isEmpty(get(civilProceedingInfo, 'assignedLawyers', [])) ||
        !validationCourtFileNumber(
          get(civilProceedingInfo, [
            CIVIL_PROCEEDING_INFORMATIONS_FIELDS.COURT_NUMBER,
          ]),
        ),
    };
    return [
      showValidationButton()
        ? [
            ...validations,
            featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
            props.isManager &&
            get(civilProceedingInfo, 'status') !== ALL_STATUS.PENDING
              ? updateJudiciaryProcess
              : null,
          ]
        : props.isManager &&
          featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER) &&
          get(civilProceedingInfo, 'status') !== ALL_STATUS.PENDING
        ? updateJudiciaryProcess
        : null,
    ]
      .flat()
      .filter(item => !isNull(item)) as any;
  };

  const successCallBack = () => {
    toast.success(translate(messages.updatedRequest, props));
    isAssignmentDialogOpen && handleCloseAssignmentDialog();
    isRejectionDialogOpen && handleCloseRejectionDialog();
  };

  const handleCloseRejectionDialog = () => {
    setIsRejectionDialogOpen(false);
  };

  const isDisabled = () => {
    return props.isManager &&
      (get(info, 'status', '') === ALL_STATUS.PENDING ||
        featureService.hasFeature(FEATURES.MANAGE_CLAIM_BY_MANAGER))
      ? false
      : true;
  };

  const Comp = Picker[`${info[`status`]}`];
  return (
    <>
      {get(civilProceedingInfo, 'updatedBy') && (
        <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
          {translate(messages.updatedByTitle, props, {
            manager: get(civilProceedingInfo, 'updatedBy'),
          })}
        </span>
      )}
      {get(civilProceedingInfo, 'status') === ALL_STATUS.REJECTED && (
        <JudgementAddDocumentDecisionRecap
          judgementAddDocument={civilProceedingInfo as any}
        />
      )}
      <CustomAccordion
        title="requête"
        textColor={COLORS.ACCORDION_TEXT_BLACK}
        bgColor={COLORS.ACCORDION_BG_YELLOW}
        image={requestRecap}
      >
        {get(info, 'courtNumber') && (
          <Request
            listings={listings}
            info={civilProceedingInfo}
            setCivilProceedingInfo={setCivilProceedingInfo}
            isUpdated={isUpdated}
            setIsUpdated={setIsUpdated}
            readOnly={isDisabled()}
          />
        )}
      </CustomAccordion>
      <CustomAccordion
        title={translate(messages.damageAffectedByTheProcedure, props)}
        textColor={COLORS.ACCORDION_TEXT_BLUE}
        bgColor={COLORS.ACCORDION_BG_BLUE}
        image={victimIcon}
      >
        <DamageAffectedByTheProcedure
          info={civilProceedingInfo}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
        />
      </CustomAccordion>
      <CustomAccordion
        title={translate(messages.audience, props)}
        textColor={COLORS.ACCORDION_TEXT_BLUE}
        bgColor={COLORS.ACCORDION_BG_BLUE}
        image={opposing}
      >
        <Audience
          info={civilProceedingInfo}
          listings={listings}
          stakeholders={stakeholders}
          setCivilProceedingInfo={setCivilProceedingInfo}
          setIsUpdated={setIsUpdated}
          lossDate={props.lossDate}
          readOnly={isDisabled()}
        />
      </CustomAccordion>
      {(!isEmpty(civilProceedingInfo.assignedLawyer) ||
        !isEmpty(get(civilProceedingInfo, 'assignment', []))) && (
        <CustomAccordion
          title={translate(messages.affectationProcedure, props)}
          textColor={COLORS.ACCORDION_TEXT_BLUE}
          bgColor={COLORS.ACCORDION_BG_BLUE}
          image={opposing}
        >
          <AssignedLawyer
            info={civilProceedingInfo}
            listings={listings}
            stakeholders={stakeholders}
            setCivilProceedingInfo={setCivilProceedingInfo}
            setIsUpdated={setIsUpdated}
            readOnly={true}
            judgementAdd={props.judgementAdd}
            judgementOnMerits={props.judgementOnMerits}
          />
        </CustomAccordion>
      )}
      <CustomAccordion
        title={translate(messages.supportingDocuments, props)}
        textColor={COLORS.ACCORDION_TEXT_BLUE}
        bgColor={COLORS.ACCORDION_BG_BLUE}
        image={opposing}
      >
        <SupportingDocuments
          info={civilProceedingInfo}
          listings={listings}
          stakeholders={stakeholders}
          setCivilProceedingInfo={setCivilProceedingInfo}
          setIsUpdated={setIsUpdated}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
      </CustomAccordion>
      <StyledDiv>
        {!isEmpty(get(info, 'status', '')) &&
          get(info, 'status', '') !== ALL_STATUS.PENDING && <Comp {...props} />}
        {((!props.isConsultation &&
          !isEmpty(get(info, 'status', '')) &&
          get(info, 'status', '') === ALL_STATUS.REJECTED &&
          get(info, 'creator', null)?.toUpperCase() ===
            currentUserStorage?.get()?.username?.toUpperCase()) ||
          (!props.isConsultation &&
            get(info, 'status', '') === ALL_STATUS.PENDING &&
            userHasPrivilege(PRIVILEGES.ISCOURTMANAGER)) ||
          (get(info, 'status', '') === ALL_STATUS.PENDING &&
            get(info, 'assignedLawyer', null) ===
              currentIntervenantStorage?.get()?.sagis_code)) && (
          <SecondaryButton
            title={translate(messages.updateTitle, props)}
            disabled={false}
            onClick={() => props.handleOpenUpdateForm(civilProceedingInfo)}
            style={{
              float: 'right',
              marginRight: 12,
              marginBottom: 12,
              marginTop: 12,
              marginLeft: 12,
            }}
          />
        )}
        {props.isManager && (
          <div className="dropdown">
            <DropDownDecisionMenu
              setDropDown={setDropDown}
              dropDown={dropDown}
              label={translate(messages.managerDecision, props)}
              menuElements={dropDownMenuElements()}
            />
          </div>
        )}
      </StyledDiv>
      <AssignmentDialog
        open={isAssignmentDialogOpen}
        onClose={handleCloseAssignmentDialog}
        setCivilProceedingInfo={setCivilProceedingInfo}
        handleValidation={validationDialog}
        civilProceedingInfo={civilProceedingInfo}
        judiciaryProcessId={props.judiciaryProcessId}
        listings={props.listings}
        requestCorporealLawyers={props.requestCorporealLawyers}
        corporealLawyers={props.corporealLawyers}
      />
      <RejectionDialog
        open={isRejectionDialogOpen}
        onClose={handleCloseRejectionDialog}
        setCivilProceedingInfo={setCivilProceedingInfo}
        handleValidation={rejectionDialog}
        civilProceedingInfo={civilProceedingInfo}
        judiciaryProcessId={props.judiciaryProcessId}
      />
    </>
  );
};

export default injectIntl(CivilProceedingRecap);
